const brInvoices = {
  hausefulInvoices: {
    total: 'Total',
    selectAll: 'Select all',
    selectedCount: '{count} invoice(s) selected',
    host: 'Host',
    customer: 'Cliente',
    invoices: 'Invoices',
    subsidiary: 'Subsidiary',
    fortnight: 'Fortnights',
    realEstate: 'Client',
    exportToExcel: 'Export to Excel',
    firstHalf: 'First fortnight',
    secondHalf: 'Second fortnight',
    noInvoices: 'No records found',
    pending: 'Pending',
    sent: 'Sent',
    paid: 'Paid',
    selectedInvoicesValue: 'Total',
    waitingApproval: 'Awaiting Approval',
    waitingTransfer: 'Awaiting Transfer',
    refused: 'Refused',
    approved: 'Approved',
    transfers: 'Transfers',
    paymentList: 'Payment List',
    received: 'Received',
    withDateLimit: 'Between {date}',
    withoutDateLimit: 'Without date limit',
    withoutPaymentLink: 'Not linked',
    emittedOutsideThePlatform: 'Asaas',
    actions: {
      download: 'Download',
      edit: 'Edit',
      show: 'View Invoice',
      showTransfer: 'View Transfer',
      exclude: 'Delete',
      sendInvoice: 'Send Invoice',
      resendInvoice: 'Resend Invoice',
      approve: 'Approve',
      refuse: 'Refuse',
      cancel: 'Cancel',
      viewInvoice: 'View invoice',
      approveSelected: 'Approve selected',
      comment: 'Comment',
      payInvoices: 'Pay invoices',
      openInvoicePdf: 'Open invoice PDF',
      linkPayments: 'Link payments',
      retryTransfer: 'Retry Transfer',
    },
    headers: {
      appointmentCode: 'Appointment Code',
      createdAt: 'Created at',
      movementValue: 'Real Estate Cost',
      hostValue: 'Host Value',
      hausefulValue: 'Hauseful Value',
      realtyQuantity: 'Quantity of Real Estates',
      transactionId: 'Transaction ID',
      status: 'Status',
      total: 'Total',
      value: 'Value',
      customer: 'Customer',
      service: 'Service',
      date: 'Date',
      description: 'Description',
      branch: 'Branch',
      actions: 'Actions',
      code: 'Code',
      createdBy: 'Created by',
      realEstate: 'Real estate',
      emission: 'Issue',
      paymentLink: 'Link',
      invoiceFile: 'Invoice',
      creation: 'Creation',
      realties: 'Properties',
      host: 'Host',
      paymentType: 'Payment Type',
      receiver: 'Receiver',
      sender: 'Sender',
      comment: 'Comment',
      transferStatus: 'Transfer Status',
      awaitingTransfer: 'Awaiting Transfer',
      document: 'Document',
      totalValue: 'Total value',
      file: 'File',
      host: 'Host',
      refuseReason: 'Refuse Reason',
      transfer: 'Transfer',
      analysis: 'Analysis',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    modals: {
      exclude: {
        title: 'Delete Invoice',
        warning: 'This action cannot be undone',
        action: 'Delete',
      },
      show: {
        title: 'View Invoice',
        createdAt: 'Created At',
        file: 'File',
        download: 'Download',
        createdBy: 'Created By',
        client: 'Client',
        branch: 'Subsidiary',
        paymentList: 'Payment List',
      },
      upload: {
        title: 'Upload Invoice',
        titleUpdate: 'Update Invoice',
        createdAt: 'Created At',
        file: 'File',
        download: 'Download',
        createdBy: 'Created By',
        client: 'Client',
        branch: 'Subsidiary',
        addFileToUpdate: 'Add file to update',
        success: 'Invoice uploaded with success.',
      },
      approve: {
        title: 'Approve Invoice',
        message: 'You are about to approve the invoice. Are you sure?',
        success: 'The invoice was approved with success.',
      },
      refuse: {
        title: 'Refuse invoice',
        message: 'You are about to refuse the invoice. Are you sure?',
        success: 'The invoice was canceled with success.',
      },
      remove: {
        title: 'Delete invoice',
        warning: 'You are about to delete the invoice. Are you sure?',
        success: 'The invoice was deleted with success.',
      },
      pay: {
        title: 'Pay invoice',
        message: 'You are about to pay the follow invoices.',
        success: 'The invoices were paid with success.',
      },
      generateAsaas: {
        title: 'Issue invoice',
        action: 'Issue invoice',
        message: 'You are about to issue the invoice via Asaas for the payments below. The emission is processed by the city hall and may take a few minutes. Do you want to continue?',
        success: 'The invoice emission has started successfully. The PDF will be available once the city hall authorizes it.',
        error: 'The invoice could not be issued. Please try again.',
      },
      generateAsaasBatch: {
        title: 'Issue selected invoices',
        action: 'Issue selected',
        selected: 'Selection',
        message: 'You are about to issue the selected invoices via Asaas. Each one is a fiscal document and the emission is processed by the city hall, which may take a few minutes. Do you want to continue?',
        success: '{count} invoice(s) sent for emission. The PDFs will be available once the city hall authorizes them.',
        partial: '{count} invoice(s) could not be issued. The others were sent and already left Pending.',
        error: 'The selected invoices could not be issued. Please try again.',
      },
      linkPayments: {
        title: 'Link payments',
        action: 'Link',
        message: 'This invoice was issued directly on Asaas and we do not know yet which inspections it covered. Pick the matching fortnight so the payments leave the pending list.',
        invoiceValue: 'Invoice value',
        matches: 'Value matches',
        payments: 'payment(s)',
        empty: 'No pending payments for this customer.',
        success: 'Payments linked to the invoice.',
        error: 'The payments could not be linked. Please try again.',
      },
      defaultActions: {
        close: 'Close',
        cancel: 'Cancel',
      },
    },
    filters: {
      title: 'Filters',
      emissionDate: 'Emission Date',
      createDate: 'Creation Date',
    },
    asaasStatus: {
      SCHEDULED: 'Processing',
      SYNCHRONIZED: 'Sent to city hall',
      AUTHORIZED: 'Authorized',
      PROCESSING_CANCELLATION: 'Cancelling',
      CANCELED: 'Cancelled',
      CANCELLATION_DENIED: 'Cancellation denied',
      ERROR: 'Emission error',
    },
    status: {
      REFUSED: 'Refused',
      APPROVED: 'Approved',
      AWAITING_APPROVAL: 'Awaiting Approval',
    },
    commentOptions: {
      noValue: 'Value not available',
      wrongValue: 'Wrong value',
      noDocument: 'Document not informed',
      wrongDocument: 'Wrong document',
      wrongCNPJ: 'Wrong CNPJ',
      wrongDescription: 'Wrong description',
      noInvoice: 'Invoice not informed',
      noServiceTaker: 'Service taker not informed',
      wrongServiceTaker: 'Wrong service taker',
      other: 'Other',
    },
    messages: {
      invoiceNotFound: 'Invoice not found',
      noInvoicePayments: 'It was not possible to send the invoice because there are no payments associated with it.',
      noPendingInvoices: 'There are no pending invoices to approve.',
      hausefulInvoices: 'Invoices sent by Hauseful',
      hostInvoices: 'Invoices sent by Hosts',
      valueMatches: 'The value matches the invoice',
      valueNotMatches: 'The value {amountValue} does not match the invoice {amountInvoiceValue}',
      documentMatches: 'The document matches the invoice',
      documentNotMatches: 'The document does not match the invoice',
      cnaeMatches: 'CNAE is valid',
      cnaeNotMatches: 'CNAE is invalid',
      reviewUnavailable: 'Review unavailable',
      reviewPassed: 'Review passed',
    },
    HAUSEFUL: 'Hauseful',
    CUSTOMER: 'Customer',
    HOST: 'Host',
  },
};

export default brInvoices;
